const TESTPORTAL_HOSTS = new Set(['testportal.phishcloud.io']);

const ALLOWED_EMAIL_DOMAINS = new Set([
  'phishcloud.com',
  'phishcloudinc.onmicrosoft.com',
]);

const ALLOWED_EXACT_EMAILS = new Set([
  'campos.j@duracell.com',
  'bertolani.m@duracell.com',
]);

export const isTestPortalHost = (hostname = window.location.hostname) => {
  const normalized = String(hostname || '')
    .trim()
    .toLowerCase();
  return TESTPORTAL_HOSTS.has(normalized);
};

export const normalizeAccessEmail = (value) =>
  String(value || '')
    .trim()
    .toLowerCase();

export const extractAccessEmail = (source) => {
  if (!source) return '';
  if (typeof source === 'string') return normalizeAccessEmail(source);

  const candidates = [
    source.email,
    source.mail,
    source.preferred_username,
    source.upn,
    source.userPrincipalName,
    source.username,
    source.user?.email,
    source.user?.mail,
    source.user?.preferred_username,
    source.profile?.email,
  ];

  for (const candidate of candidates) {
    const normalized = normalizeAccessEmail(candidate);
    if (normalized.includes('@')) {
      return normalized;
    }
  }
  return '';
};

export const isEmailAllowedOnTestPortal = (emailOrUser) => {
  const email = extractAccessEmail(emailOrUser);
  if (!email || !email.includes('@')) {
    return false;
  }
  if (ALLOWED_EXACT_EMAILS.has(email)) {
    return true;
  }
  const domain = email.split('@')[1] || '';
  return ALLOWED_EMAIL_DOMAINS.has(domain);
};

/**
 * Returns true when the current host allows this identity.
 * Non-testportal hosts (prod, localhost) always allow.
 */
export const isAllowedOnCurrentHost = (emailOrUser) => {
  if (!isTestPortalHost()) {
    return true;
  }
  return isEmailAllowedOnTestPortal(emailOrUser);
};

export const TESTPORTAL_ACCESS_DENIED_MESSAGE =
  'Access to testportal is restricted. Contact PhishCloud if you need access.';
